import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Button } from '@material-ui/core';
import FormDialog from "../../../../../components/FormDialog/FormDialog"
import db from "../../../../../db"
import { toast } from 'react-toastify';


const useStyles = makeStyles(theme => ({
  root: {},
  row: {
    height: '42px',
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(1)
  },
  spacer: {
    flexGrow: 1
  },

}));

const Toolbar = props => {
  const { className, ...rest } = props;

  const classes = useStyles();

  const [op, setOp] = useState(false)
  let [productStatus, setProductStatus] = useState()
  let [checkStatus, setCheckStatus] = useState()



  const fields = [
    {
      id: "productStatus",
      label: "Արտադրանքի կարգավիճակ",
      type: "text",
      value: productStatus,
      func: setProductStatus
    },
    {
      id: "checkStatus",
      label: "Ստուգման կարգավիճակ",
      type: "text",
      value: checkStatus,
      func: setCheckStatus
    }
  ]

  const handleAdd = () => {
    if (productStatus && checkStatus) {
      db.ref().child('ProductStatuses').push({
        productStatus: productStatus,
        checkStatus: checkStatus
      }).then(() => {
        setProductStatus()
        setCheckStatus()
        toast.success('Ավելացված է');
        setOp(false)
      })
    } else {
      toast.error('Լրացրեք բոլոր դաշտերը')
    }
  }

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <h2>Արտադրանքի կարգավիճակներ</h2>
      <div className={classes.row}>
        <span className={classes.spacer} />
        <Button
          // className={classes.btn}
          color="primary"
          variant="contained"
          onClick={() => { setOp(true) }}
          style={{ marginBottom: "10px" }}
        >
          Ավելացնել
                        </Button>
        <FormDialog op={op} setOp={setOp} title="Ավելացնել ստատուս" func={handleAdd} fields={fields} />

      </div>

    </div>
  );
};

Toolbar.propTypes = {
  className: PropTypes.string
};

export default Toolbar;
